<template>
  <v-app>
    <BanobagiClose v-if="isSiteClosed" data-test="banobagi-closed-screen" />
    <div
      v-else
      id="app-container"
      data-test="app-container"
      class="container-lg p-0"
      :class="{
        'new-theme': lineLayout.includes('Minimal'),
        'banobagi-app': isBanobagi
      }"
    >
      <Header
        v-if="
          isLoadingTheme &&
          !isShowHeader &&
          (!isStandardV2 || $route.meta.isShowV1Header)
        "
        @updateView="updateView"
        :isShowing="isShowing"
      />

      <div class="container-router">
        <!-- {{ hideFooter }} -->
        <div
          :class="
            isShowing
              ? 'background-telephone-color'
              : background
              ? 'background-color'
              : 'background-image'
          "
        ></div>

        <template v-if="readyToUse">
          <BanobagiLayout v-if="isBanobagi">
            <router-view :key="componentKey"> </router-view>
          </BanobagiLayout>
          <StandardV2Layout v-else-if="isStandardV2">
            <router-view :key="componentKey"> </router-view>
          </StandardV2Layout>
          <router-view v-else :key="componentKey"> </router-view>
          <div class="nav-footer" v-if="showFooter">
            <div
              @click="$router.push('/profile')"
              :class="[
                activePath == '/profile' ? 'active' : '',
                'nav-footer-items'
              ]"
            >
              <font-awesome-icon :icon="['fas', 'home']" />
            </div>
            <div
              @click="$router.push('/privilege')"
              :class="[activePath == '/privilege' ? 'active' : '']"
              class="position-relative nav-footer-items"
            >
              <v-badge
                color="error"
                pill
                class="badge-redeem"
                v-if="$store.state.shortProfile.total_coupon_can_use > 0"
                :content="$store.state.shortProfile.total_coupon_can_use"
              >
                <!-- <span>{{}}</span> -->
              </v-badge>
              <font-awesome-icon :icon="['fas', 'ticket-alt']" />
            </div>
            <div
              :class="[activePath == '/reward' ? 'active' : '']"
              class="nav-footer-items"
              @click="$router.push('/reward')"
            >
              <font-awesome-icon :icon="['fas', 'gift']" />
            </div>
            <div
              :class="[activePath == '/manage' ? 'active' : '']"
              class="nav-footer-items"
              @click="$router.push('/manage')"
            >
              <font-awesome-icon :icon="['far', 'user']" />
            </div>
          </div>
        </template>
        <template v-else>
          <Redirect />
        </template>
        <div class="menu-panel" v-if="isShowFooter">
          <div @click="$router.push('/transaction-summary')">
            <span :class="['icon-banner', { isActive: isProfile }]">
              <c-img
                :src="require('@/assets/images/miniprofile/purchase.png')"
                @error="handleImageSrc"
                style="width: 16px; height: 16px"
                alt="user icon tabs"
              />
            </span>
            <div data-lang="minimal_transaction_tab_title" class="f-helper">
              {{ $t("minimal_transaction_tab_title") }}
            </div>
          </div>
          <div @click="$router.push('/profile')">
            <div :class="['icon-banner', { isActive: !isProfile }]">
              <c-img
                :src="require('@/assets/images/miniprofile/profile.png')"
                @error="handleImageSrc"
                class="icon-tabs"
                alt="user icon tabs"
              />
            </div>
            <div data-lang="minimal_profile_tab_title" class="f-helper">
              {{ $t("minimal_profile_tab_title") }}
            </div>
          </div>
          <div v-if="customLink.length > 0">
            <!-- {{ customLink }} -->
            <div
              class="profile-tabs"
              :ripple="false"
              @mousedown.stop.prevent
              @click="openLink(customLink?.[0])"
              @keydown.stop.prevent
            >
              <div
                class="d-flex flex-column align-center justify-center"
                style="row-gap: 0.35rem"
              >
                <c-img
                  :src="customLink[0].details[0].name"
                  class="icon-tabs"
                  alt="more"
                />
              </div>

              <v-menu
                v-if="customLink.length > 1"
                activator="parent"
                location="top"
                :close-on-content-click="true"
              >
                <v-list density="compact">
                  <v-list-item
                    v-for="link of customLink"
                    :href="getUrlLink(link)"
                    target="_blank"
                    rel="noopener"
                  >
                    <v-list-item-title class="px-3">
                      <div class="d-flex align-items-center">
                        <c-img
                          :src="link.details[0].image_url"
                          class="custom-link-image mr-2"
                        ></c-img>
                        {{ link.details[0].name }}
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="f-helper">{{ customLink[0].details[0].name }}</div>
          </div>
        </div>
      </div>
      <!-- <footer v-if="!hideFooter" class="logo-footer">
        <c-img-lazy
          :src="
            $store.state.domain +
            ($store.state.theme.theme_footer_image ||
              $store.state.theme.themeLogoLine)
          "
          class="footer-img"
        />
      </footer> -->
      <Modal />
      <ModalLoading ref="modalLoading" />
      <Toast ref="toast" />
      <DialogContainer />
    </div>
  </v-app>
</template>

<script>
import Loading from "@/components/other/Loading";
import Header from "@/views/layout/Header";
import Redirect from "@/views/redirect";
import Modal from "@/components/modal";
import ModalLoading from "@/components/other/ModalLoading.vue";
import Toast from "@/components/other/Toast.vue";
import DialogContainer from "@/components/DialogContainer.vue";
import StandardV2Layout from "@/views/layout/StandardV2Layout.vue";
import BanobagiLayout from "@/views/layout/BanobagiLayout.vue";
import { useRouter } from "vue-router";
import { useDialog } from "@/services/dialogService";
import UserQRDialogContent from "@/components/dialog-content/UserQRDialogContent.vue";
import { mapState, mapGetters } from "vuex";
import {
  appendAuthTokensToUrl,
  getInternalPathWithoutQuery,
  isExternalRedirect
} from "@/utils/redirect";
import { isBanobagiLayout } from "@/utils/layout";
import BanobagiClose from "@/views/page/banobagi/Close.vue";
import { useBanobagiAvailability } from "@/composables/useBanobagiAvailability";
import { isBanobagiSiteClosed } from "@/utils/banobagiAvailability";

export default {
  components: {
    BanobagiClose,
    Header,
    Modal,
    Loading,
    Redirect,
    ModalLoading,
    Toast,
    DialogContainer,
    StandardV2Layout,
    BanobagiLayout
  },

  setup() {
    const dialog = useDialog();
    return { dialog, ...useBanobagiAvailability() };
  },

  data() {
    return {
      setData: "",
      theme: {},
      isLoadingTheme: false,
      isLoading: false,
      background: false,
      MenuList: [],
      activePath: "",
      setProfile: false,
      componentKey: 1,
      isProfile: true,
      hideFooter: false,
      customLink: [],
      _vv: null,
      _onVVResize: null,
      _baseH: 0
    };
  },

  watch: {
    isSiteClosed(closed) {
      if (closed) {
        this.$router.replace({ name: "Banobagi Close" });
        return;
      }
      // ตอนเว็บปิดแอปข้าม LIFF init และ login จึงต้องโหลดใหม่เมื่อถึงเวลาเปิด
      window.location.reload();
    },
    "$route.path": {
      handler: function (to, from, val) {
        this.activePath = to;
        if (this.lineLayout == "Compact") this.hideFooter = true;
        else this.hideFooter = false;
        if (to == "/profile" || to.includes("/transaction-summary"))
          this.hideFooter = true;
        if (this.isStandardV2) this.hideFooter = true;

        document.body.style.setProperty(
          "--logo-footer-height",
          this.hideFooter ? "0px" : "48px"
        );

        if (this.$config.isMinimalSharp) {
          let bodyStyles = document.body.style;
          if (to.includes("/profile"))
            bodyStyles.setProperty("--padding-footer", "80px");
          else bodyStyles.setProperty("--padding-footer", "150px");
        }
        if (to) {
          this.isProfile = to.includes("/transaction-summary") ? true : false;
          // this.emiiter.emit("hideModal");
        }
      },
      deep: true,
      immediate: true
    }
  },
  async beforeCreate() {},
  async created() {
    this.getTheme();
    if (this.isSiteClosed) return;

    this.checkCookieAvailability();

    try {
      if (this.$config.isLoginLine)
        if (!this.$liff.isLoggedIn()) {
          // alert(`login ${window.location.search}`);
          const url = new URL(window.location.href);
          const params = url.searchParams;
          if (!params.has("redirect")) {
            const currentPath = window.location.pathname;
            params.set("redirect", currentPath);
          }
          const redirectUri = window.location.origin + "?" + params.toString();

          return this.$liff.login({
            redirectUri: redirectUri
          });
        }

      const router = useRouter();
      await router.isReady();
      if (isBanobagiSiteClosed()) return;
      if (window.Cypress) {
        await this.$store.dispatch("getProfileFromLine");
      }
      if (this.$route.query["no-header"] === "true") {
        window.sessionStorage.setItem("enteredWithNoHeader", "true");
      }

      // if (!this.$cookies.isKey("token")) {
      const token = await this.getToken();

      // login อาจคืน error object หรือ { result: 0 } ที่ไม่มี detail
      const tok = token?.detail?.token || this.$cookies.get("token");
      const memberId = token?.detail?.member_id_encryption || "";
      const userProfileTok =
        this.$cookies.get("user_profile_token")?.userId || "";

      const to = this.$route?.query?.to;
      const isLogin =
        this.$route.query.isLogin !== undefined
          ? this.$route.query.isLogin === "true"
          : true;

      if (typeof to === "string" && to.length > 0 && this.isUser && isLogin) {
        setTimeout(async () => {
          if (isBanobagiSiteClosed()) return;
          let isInLine = await this.$liff.isInClient();
          if (isBanobagiSiteClosed()) return;
          if (isExternalRedirect(to)) {
            try {
              const appended = appendAuthTokensToUrl(to, {
                token: tok,
                lineToken: userProfileTok,
                memberToken: memberId
              });

              if (isInLine)
                return this.$liff.openWindow({
                  url: appended
                });

              return (window.location.href = appended);
            } catch {
              this.$logger({
                response: {
                  config: {
                    url: to,
                    methods: "REDIRECT",
                    data: JSON.stringify({ hasToken: Boolean(tok) })
                  }
                },
                action: { id: 3, action: "redirect with auth token" }
              });
              this.isLoading = true;
            }
          } else {
            await this.$router.replace({
              path: getInternalPathWithoutQuery(to)
            });
            this.isLoading = true;
          }
        }, 300);
      }
      if (to && isLogin && this.isUser) return;
      if (this.isUser && !this.shouldProfileLoadInPage) {
        await this.getProfile();
      }

      this.isLoading = true;
    } catch (error) {
      this.$logger({
        response: error.response || {
          config: { url: "App.created", methods: "INIT" }
        },
        action: { id: 3, action: "initialize app auth flow" }
      });
      // ให้ router guard จัดการต่อ แทนที่จะค้างหน้า loading
      this.isLoading = true;
    }
  },
  mounted() {
    if (this.isSiteClosed) return;
    this.emitter.on("openProfileModal", () => this.modalQR());
    this.emitter.on("closeProfileModal", () => this.hideQr());
    this.emitter.on("showLoading", (type, brand, isPdf) => {
      this.$refs.modalLoading?.show();
    });
    this.emitter.on("hideLoading", () => this.$refs.modalLoading?.hide());
    this.emitter.on("showToast", payload => {
      const opts =
        typeof payload === "string" ? { message: payload } : payload || {};
      this.$refs.toast?.show(opts);
    });
    this.emitter.on("updateView", this.updateView);
    this.getCustomLink();
    const vv = window.visualViewport;
    if (!vv) return;

    this._vv = vv;

    this._baseH = Math.max(window.innerHeight, vv.height);

    const onResize = () => {
      const kb = Math.max(0, 200);
      document.documentElement.style.setProperty("--kb", `${kb}px`);
    };
    // this._onVVResize = onResize;

    // vv.addEventListener("resize", onResize);
    // vv.addEventListener("scroll", onResize);

    // onResize();

    // setTimeout(onResize, 150);
    // setTimeout(onResize, 300);
  },
  computed: {
    isBanobagi() {
      return this.$isBanobagi === true || isBanobagiLayout(this.lineLayout);
    },
    isStandardV2() {
      return this.$isStandardV2 === true || this.lineLayout === "standard-v2";
    },
    shouldProfileLoadInPage() {
      return this.$route.path === "/profile";
    },
    showFooter() {
      if (this.isStandardV2) return false;

      if (
        this.theme.line_layout == "Compact" &&
        (this.$route.name == "profile" ||
          this.$route.name == "manage profile" ||
          this.$route.name == "reward" ||
          this.$route.name == "privilege")
      ) {
        let bodyStyles = document.body.style;

        bodyStyles.setProperty("--padding-footer", "130px");
        return true;
      } else if (this.theme.line_layout.includes("Minimal")) {
        let bodyStyles = document.body.style;
        if (this.$isMinimalMinibar)
          if (
            this.$route.name == "profile" ||
            this.$route.name == "manage profile" ||
            this.$route.name == "reward" ||
            this.$route.name == "privilege"
          )
            bodyStyles.setProperty("--padding-footer", "100px");
          else bodyStyles.setProperty("--padding-footer", "180px");
        else if (this.$isCleanLayout)
          bodyStyles.setProperty("--padding-footer", "130px");
        else if (this.$isMinimalProfile) {
          bodyStyles.setProperty("--padding-footer", "150px");
        } else if (this.$isShowTab)
          bodyStyles.setProperty("--padding-footer", "95px");
        else if (!this.$config.isMinimalSharp)
          bodyStyles.setProperty("--padding-footer", "75px");
        else bodyStyles.setProperty("--header-height", "60px");
        bodyStyles.setProperty("--header-height", "80px");
      } else {
        let bodyStyles = document.body.style;

        bodyStyles.setProperty("--padding-footer", "80px");
      }

      return false;
    },
    isShowFooter() {
      if (!this.$isMinimalProfile && !this.$isMinimalProfileBanner)
        return false;
      if (
        this.$route.name == "validatetelephone" ||
        this.$route.name == "confirmotp" ||
        this.$route.name == "confirmotpedit" ||
        this.$route.name == "editprofile-telephone" ||
        this.$route.name == "review" ||
        this.$route.name == "register" ||
        this.$route.name == "editprofile" ||
        this.$route.path?.includes("/transaction-summary/")
      )
        return false;
      return true;
    },
    isShowing() {
      if (this.lineLayout == "Minimal" || this.lineLayout == "Standard")
        return false;
      if (
        this.$route.name == "validatetelephone" ||
        this.$route.name == "confirmotp" ||
        this.$route.name == "confirmotpedit" ||
        this.$route.name == "editprofile-telephone" ||
        this.$route.name == "editprofile" ||
        this.$route.name == "review" ||
        this.$route.name == "register"
      )
        return true;
      return false;
    },
    isShowHeader() {
      document.body.style.setProperty("--margin-navbar", "80px");
      if (
        (this.$isMinimalProfile || this.$isMinimalProfileBanner) &&
        (this.$route.name == "Transaction-Summary" ||
          this.$route.name == "Transaction-Summary-Detail" ||
          this.$route.name == "Transaction-Summary-Detail-RECEIPT" ||
          this.$route.name == "editprofile")
      )
        return true;

      const enteredFromQuery =
        sessionStorage.getItem("enteredWithNoHeader") === "true" ||
        this.$route.query["no-header"];

      document.body.style.setProperty("--margin-navbar", "80px");
      return enteredFromQuery;
    },
    readyToUse() {
      return this.isLoading && this.isReady;
    },
    isReady() {
      return this.$store.state.templateReady;
    },
    ...mapState(["isUser"]),
    ...mapGetters({
      profile: "getProfile"
    })
  },
  methods: {
    checkCookieAvailability() {
      const probeKey = "__cookie_probe__";
      let cookieEnabled = false;
      let reason = "";

      try {
        if (
          typeof navigator !== "undefined" &&
          navigator.cookieEnabled === false
        ) {
          reason = "navigator.cookieEnabled=false";
        } else {
          this.$cookies.set(probeKey, "1", "1min");
          const readBack = this.$cookies.get(probeKey);
          this.$cookies.remove(probeKey);
          cookieEnabled = readBack === "1";
          if (!cookieEnabled) reason = "probe write/read mismatch";
        }
      } catch (e) {
        reason = e?.message || "exception on cookie probe";
      }

      if (!cookieEnabled) {
        this.$logger({
          response: {
            config: {
              url: "App.created",
              methods: "COOKIE_CHECK",
              data: JSON.stringify({
                reason,
                userAgent:
                  typeof navigator !== "undefined" ? navigator.userAgent : "",
                href: typeof window !== "undefined" ? window.location.href : ""
              })
            }
          },
          action: { id: 3, action: "cookies unavailable" }
        });
      }

      return cookieEnabled;
    },
    modalQR() {
      this.dialog.showCustom(UserQRDialogContent, {
        profile: this.profile,
        userProfile: this.$store.state.userProvider
      });
    },
    hideQr() {
      this.dialog.closeDialog({ action: "close" });
    },
    invertColor(hex, bw) {
      if (!hex) return;
      if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
      }

      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
      }
      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
    },
    async getTheme() {
      var data = this.$store.state.theme;

      this.theme = this.$store.state.theme;

      function hexToRgbA(hex, opacity = 0.7) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          c = hex.substring(1).split("");
          if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c = "0x" + c.join("");
          return (
            "rgba(" +
            [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
            `,${opacity})`
          );
        }
      }
      this.background = data.themeBackgroundPage == 1 ? true : false;
      let secondaryColorLight = hexToRgbA(data.themeSecondaryColorLine, 0.4);
      let primaryColorLow = hexToRgbA(data.themePrimaryColor, 0.1);
      let LightColor = hexToRgbA(data.themeLightPrimaryColor, 0.1);
      let bodyStyles = document.body.style;
      bodyStyles.setProperty("--primary-color", data.themePrimaryColor);

      bodyStyles.setProperty(
        "--currency-sign",
        this.$t("currency_sign") || "฿"
      );
      bodyStyles.setProperty("--primary-color-low", primaryColorLow);
      bodyStyles.setProperty("--secondary-color", data.themeSecondaryColorLine);
      bodyStyles.setProperty("--secondary-color-light", secondaryColorLight);
      bodyStyles.setProperty("--light-color", data.themeLightPrimaryColor);
      bodyStyles.setProperty("--light-color-low", LightColor);
      bodyStyles.setProperty("--disable-color", data.themeDisableColor);
      bodyStyles.setProperty(
        "--font-color",
        this.invertColor(data.themeSecondaryColorLine, true)
      );
      bodyStyles.setProperty(
        "--font-primary-color",
        this.invertColor(data.themePrimaryColor, true)
      );
      bodyStyles.setProperty(
        "--font-button-color",
        this.invertColor(data.button_color, true)
      );
      bodyStyles.setProperty("--button-color", data.button_color);
      bodyStyles.setProperty(
        "--font-disable-color",
        this.invertColor(data.themeDisableColor, true)
      );
      bodyStyles.setProperty("--theme-background-color", data.themeSolidColor);
      bodyStyles.setProperty("--text-color", data.font_color);
      bodyStyles.setProperty("--bar-color", data.bar_color);
      bodyStyles.setProperty("--tab-text-color", data.themeNavigationBarColor);
      bodyStyles.setProperty("--reward-icon-color", data.themePrimaryColor);
      bodyStyles.setProperty(
        "--theme-navigation-bar-color",
        data.themeNavigationBarColor
      );
      bodyStyles.setProperty(
        "--theme-background-image",
        `url(${this.$store.state.domain}${data.themeBackGround})`
      );
      bodyStyles.setProperty("--tier-bar-color", data.tier_bar_color);
      bodyStyles.setProperty("--tier-maintain-point", data.tier_maintian_color);
      bodyStyles.setProperty("--tier-upgrade-point", data.tier_upgrade_point);
      if (this.$isLacoste) {
        bodyStyles.setProperty("--crm-input-border-radius", "8px");
        bodyStyles.setProperty(
          "--crm-input-border-color",
          "rgba(117, 117, 117, 0.575)"
        );
      }
      if (this.$isBanobagi) {
        bodyStyles.setProperty("--crm-input-border-radius", "999px");
        bodyStyles.setProperty("--crm-border-radius", "999px");
      }
      bodyStyles.setProperty("--tier-upgrade-point", data.tier_upgrade_point);
      // this.genarateFont(data);
      this.isLoadingTheme = true;
    },

    async getToken() {
      return await new Promise((resolve, reject) => {
        setTimeout(async () => {
          const res = await this.$store.dispatch("login");
          resolve(res);
        }, 0);
      });
      // return res;
    },
    async getProfile() {
      if (this.$cookies.isKey("token"))
        await new Promise((resolve, reject) => {
          setTimeout(async () => {
            const res = await this.$store.dispatch("getUserProfile");
            resolve();
          }, 0);
        });
      return;
    },
    async updateView() {
      await this.$nextTick();
      this.componentKey += 1;
    },
    async getCustomLink() {
      const res = await this.$axios("/api/v1/setting/customlink/list");
      this.customLink = res.detail.filter(el => el.status == 1);
    },
    openLink(value) {
      let url = this.getUrlLink(value);
      if (this.customLink.length > 1) return;
      function isValidHttpUrl(string) {
        let url;
        try {
          url = new URL(string);
        } catch (_) {
          return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
      }
      let check = isValidHttpUrl(url);

      return !check ? window.open("https://" + url) : window.open(url);
    },
    getUrlLink(link) {
      let lang = this.$cookies.get("lang");
      let getURL = link.details.find(el => el.language_id == lang.lang);
      return getURL.url;
    }
  },
  beforeDestroy() {
    if (this._vv && this._onVVResize) {
      this._vv.removeEventListener("resize", this._onVVResize);
      // this._vv.removeEventListener("scroll", this._onVVResize);
    }
  }
};
</script>
<style lang="scss">
.icon-tabs {
  width: 16px;
  height: 16px;
  margin-left: 2px;
}
:root {
  --margin-navbar: 80px;
  --logo-footer-height: 48px;
}
.content-page {
  padding-bottom: var(--logo-footer-height);
}
.content {
  position: fixed;
  background-color: #fff;
  width: 100%;
}
/* .background-b {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  position: absolute;
  width: 100%;
  min-height: 100dvh;
  background: linear-gradient(
    0deg,
    var(--secondary-color) 0%,
    var(--primary-color) 100%
  );
} */
.background-color {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  min-height: 100dvh;
  z-index: -1;
  background-color: var(--theme-background-color);
}
.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100dvh;
  height: 100%;
  z-index: -1;
  /* overflow: hidden; */
  background-image: var(--theme-background-image);
}
.background-telephone-color {
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  /* position: fixed; */
  width: 100%;
  top: 0;
  /* min-height: calc(100dvh - 80px); */
  z-index: -1;
  background-color: white;
  overflow: hidden;
}
.nav-footer {
  background: white;
  color: black;
  font-size: 28px;
  width: 100%;
  display: inline-flex;
  position: fixed;
  bottom: 0;
  height: 60px;
  z-index: 1;
  justify-content: space-around;
  align-items: center;
  box-shadow: -1px 9px 16px 0px rgb(138, 138, 138);
}
.badge-redeem {
  position: absolute;
  top: 4px;
  font-size: var(--font-helper) !important;
  right: -8px;
}
.nav-footer-items {
  color: gainsboro;
}
.nav-footer-items.active {
  color: black;
}
.menu-panel {
  border-top: 0.5px solid #d0d0d0;
  position: fixed;
  bottom: 0;
  background: rgb(250, 250, 250);
  width: 100%;
  height: auto;
  padding: 1rem;
  // border-radius: var(--crm-input-border-radius);
  display: flex;
  div:first-child {
    // border-right: 1px solid #afafaf;
  }
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 0.5rem;
    font-size: var(--font-body);
  }
}
.icon-banner {
  &.isActive {
    opacity: 1;
  }
  opacity: 0.4;
}
.footer-img {
  width: auto;
  // max-width: 200px;
  height: auto;
  max-height: 12px;
  // margin: unset !important;
}
footer {
  // padding: 0;
  justify-content: center;
  max-height: 50px;
  z-index: 999;
  background-color: var(--theme-background-color) !important;
}
.logo-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  height: 48px;
  padding: 12px;
  background: #fff;
  align-content: center;
  text-align: center;
}
</style>
